import React ,{useEffect} from 'react';
import { Grid, Typography,Box } from '@mui/material';
import FeatureCard from '../FeatureCard/FeatureCard';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAboutUsData } from './../../../redux/slices/aboutUsFeatureSlice';
import SectionTitle from '../../SectionTitle/SectionTitle';
import daimond from './../../../assets/images/service/ri_diamond-line.png'
import Commitment from './../../../assets/images/service/Commitment.png'
import fluent_people from './../../../assets/images/service/fluent_people-star-16-regular.png'
import divorce from './../../../assets/images/service/divorce.png';
import Loading from '../../UI/Loading/Loading';
const FeatureGrid = ({ t, language }) => {
    const featureImages = [divorce, daimond,  Commitment, fluent_people];
    const dispatch = useDispatch();
    const { data: aboutUsData, loading, error } = useSelector((state) => state.aboutUsFeature);
    // console.log("aboutUsData",aboutUsData);
    
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await dispatch(fetchAboutUsData({ language }));
                // console.log("Response from fetchAboutUsData:", response);
            } catch (error) {
                // console.error("Error fetching About Us data:", error);
            }
        };
    
        fetchData();
    }, [dispatch, language]);
    
 // Combine API data and static features with images
 const features = aboutUsData.map((item, index) => {
    const description = item.aboutUsDescription.find((desc) => 
        language === 'Arabic' ? desc.valueAr : desc.valueEn
    );
    return {
        imgSrc: featureImages[index] || divorce, // Fallback image
        title:  item.name ,
        description: description ? (language === 'Arabic' ? description.valueAr : description.valueEn) : 'No description available',
    };
});

    if (loading) {
        return  <Loading />;
    }
//   if (error) {
//     return <Typography>Error: {error}</Typography>;
//   }

  return (
    <Box sx={{ mt: '64px', textAlign: "center", mb: "64px" }}>

    <SectionTitle
        title={t.whyChooseGwen}
        fontSize="32px"
        color="#12538B"
        fontWeight={700}
        lineHeight="39.08px"
        mb={16}
        dataAos="fade-down"
    />
  <Grid container spacing={4} sx={{ backgroundColor: "#12538B", width: "100%", paddingLeft: "0px !important", ml: "0px !important" }}>
    {features.map((feature, index) => (
        <Grid item xs={12} sm={6} md={3} key={index}>
            <FeatureCard
                imgSrc={feature.imgSrc}
                title={feature.title}
                description={feature.description}
            />
        </Grid>
    ))}
        </Grid>
</Box>
   
  );
};

export default FeatureGrid;
